import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeRequest } from "../../api/api";
import { actions } from "react-table";
import axios from 'axios';
 
export const filterSurplusPooling = createAsyncThunk(
  'pooling/filterSurplusPooling',
  async (params) => {
    console.log("params", params);
 
    let queryString = "";
    if (params) {
      queryString = "?" + new URLSearchParams(params).toString();
    }
 
    const request = await makeRequest("get", `v2/pooling/get_filter_data/${queryString}`);
    const response = request.data.data;
    return response;
  }
);
 
export const filterDeficitPooling = createAsyncThunk(
  'pooling/filterDeficitPooling',
  async (params) => {
    console.log("params", params);
    let queryString = "";
    if (params) {
      queryString = "?" + new URLSearchParams(params).toString();
    }
 
    const request = await makeRequest("get", `v2/pooling/get_filter_data/${queryString}`);
    const response = request.data.data;
    return response;
  }
);
 
export const getPoolRedirectData = createAsyncThunk(
  'pooling/getPoolRedirectData',
  async (params) => {
    console.log("params", params);
    let queryString = "";
    if (params) {
      queryString = "?" + new URLSearchParams(params).toString();
    }
 
    const request = await makeRequest("get", `v2/pooling/redirect_pool_data/${queryString}`);
    const response = request.data.data;
    return response;
  }
);
 
export const updateVesselTable = createAsyncThunk(
  'pooling/updateVesselTable',
  async (params) => {
    console.log("params", params);
 
    let queryString = "";
    if (params) {
      queryString = "?" + new URLSearchParams(params).toString();
    }
 
    const request = await makeRequest("get", `v2/pooling/update_vessel_data/${queryString}`);
    const response = request.data.data;
    return response;
  }
);
 
 
export const initiatePooling = createAsyncThunk(
  'pooling/initiatePooling',
  async (payload) => {
    const request = await makeRequest("post", `v2/pooling/generate_pool_request/`,payload);
    const response = request.data.data;
    return response;
  }
);
 
export const deletePool = createAsyncThunk(
  'pooling/deletePool',
  async (payload) => {
    const request = await makeRequest("post", `v2/pooling/delete_pool/`,payload);
    const response = request.data.data;
    return response;
  }
);
 
export const UpdateFinalPrice = createAsyncThunk(
  'pooling/UpdateFinalPrice',
  async (payload) => {
    const request = await makeRequest("patch", `v2/pooling/update_final_price_value/`,payload);
    const response = request.data.data;
    return response;
  }
);
 
export const getManualPoolPricebreakdown = createAsyncThunk(
  'pooling/getManualPoolPricebreakdown',
  async (payload) => {
    const request = await makeRequest("post", `v2/pooling/get_price_breakdown_for_manual_pool/`,payload);
    const response = request.data.data;
    return response;
  }
);
 
export const poolingHistoryOpenDetails = createAsyncThunk(
  'pooling/poolingHistoryOpenDetails',
  async (params) => {
    let queryString = "";
    if (params) {
      queryString = "?" + new URLSearchParams(params).toString();
    }
    const request = await makeRequest("get", `v2/pooling/get_pool_details/${queryString}`);
    const response = request.data.data;
    return response;
  }
);
 
export const poolingHistory = createAsyncThunk(
  'pooling/poolingHistory',
  async (params) => {
    const { page, sortType } = params;
    const request = await makeRequest("get", `v2/pooling/get_pooling_history/?requested_page=${page}&sort_type=${sortType}`);
    console.log("request", request);
    const response = request.data;
    return response;
  }
);
 
export const fetchCompanySummary = createAsyncThunk(
  'pooling/fetchCompanySummary',
  async (pool_id) => {
    const response = await makeRequest("get", `v2/pooling/api/pool_details_api/${pool_id}/`);
    return response.data;
  }
);
 
 
export const suggestionFilter = createAsyncThunk(
  'pooling/suggestionFilter',
  async (params) => {
    console.log("params", params);
 
    let queryString = "";
    if (params) {
      queryString = "?" + new URLSearchParams(params).toString();
    }
 
    const request = await makeRequest("get", `v2/pooling/get_suggestion_for_pool/${queryString}`);
    const response = request.data.data;
    return response;
  }
);
 
export const uploadCompanyDoc = createAsyncThunk(
  'pooling/uploadCompanyDoc',
  async ({ pool_id, company_name, doc_type, file }) => {
    const formData = new FormData();
    formData.append('pool_id', pool_id);
    formData.append('company_name', company_name);
    formData.append('doc_type', doc_type);
    formData.append('file', file);
 
    const response = await makeRequest("post", `v2/pooling/api/upload_company_doc/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return {
      pool_id,
      company_name,
      doc_type,
      file_url: response.data.file_url
    };
  }
);
 
export const downloadCompanyDoc = createAsyncThunk(
  'pooling/downloadCompanyDoc',
  async ({ companyName, docType }, { rejectWithValue }) => {
    try {
      const response = await makeRequest(
        'get',
        `v2/pooling/api/download_company_doc/${encodeURIComponent(companyName)}/${encodeURIComponent(docType)}/`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);
 
export const upload_company_documents = createAsyncThunk(
  "pooling/upload_company_documents",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await makeRequest(
        "post",
        `v2/pooling/upload_company_documents/`,
        formData
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);
 
export const updatePoolDocument = createAsyncThunk(
  "pooling/updatePoolDocument",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await makeRequest(
        "patch",
        `v2/pooling/update_pool_document/`,
        formData
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);
 
export const getPoolDocuments = createAsyncThunk(
  "pooling/getPoolDocuments",
  async ({ poolId, companyName }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (poolId) params.append("pool_id", poolId);
      if (companyName) params.append("company_name", companyName);
 
      const response = await makeRequest(
        "get",
        `v2/pooling/get_pool_documents/?${params.toString()}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);
 
export const getPoolDocumentSignedUrl = createAsyncThunk(
  "pooling/getPoolDocumentSignedUrl",
  async ({ poolId, companyName, docType, storagePath }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (poolId) params.append("pool_id", poolId);
      if (companyName) params.append("company_name", companyName);
      if (docType) params.append("doc_type", docType);
      if (storagePath) params.append("storage_path", storagePath);
 
      const queryString = params.toString();
      const url = queryString
        ? `v2/pooling/get_pool_document_signed_url/?${queryString}`
        : `v2/pooling/get_pool_document_signed_url/`;
 
      const response = await makeRequest("get", url);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);
 
export const deleteAllPoolDocuments = createAsyncThunk(
  "pooling/deleteAllPoolDocuments",
  async ({ poolId, companyName }, { rejectWithValue }) => {
    try {
      const response = await makeRequest(
        "delete",
        `v2/pooling/delete_all_pool_documents/`,
        {
          pool_id: poolId,
          company_name: companyName,
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { error: err.message });
    }
  }
);
 
export const updateManualPriceBreakDown = createAsyncThunk(
  'pooling/updateManualPriceBreakDown',
  async (data) => {
    const request = await makeRequest("post", `v2/pooling/return_red_breakdown/`,data);
    const response = request.data.data;
    return response;
  }
);
 
export const saveOrUpdatePool = createAsyncThunk(
  'pooling/saveOrUpdatePool',
  async (data) => {
    const request = await makeRequest("post", `v2/pooling/save_or_update_pool/`,data);
    const response = request.data.data;
    return response;
  }
);
 
 
 
 
 
const poolingSlice = createSlice({
  name: "pooling",
  initialState: {
    status: 'idle',
    initiatepoolstatus: "failed",
    poolingHistoryData: [],
    surplusPoolingData: [],
    deficitPoolingData: [],
    poolRedirectData: [],
    manualPriceBreakDown: [],
    poolingHistoryPaginationData: {},
    shipOwners:[],
    IMOnumbers:[],
    poolDetailsData: [],
    tableDataUpdated: false,
    intiatedpoolingData: [],
    initiatedpoolingloading: false,
    updatepoolingloading: false,
    filterSurplusValues: [],
    filterDeficitValues: [],
    count: null,
    page: 1,
    companyDocuments: {},
    error: null,
    loading: false,
  },
  reducers: {
    updateManualPriceBreakDownData: (state, action) => {
      state.manualPriceBreakDown = action.payload;
    },
    addSurplusFilterValue: (state, action) => {
      if (!action.payload || typeof action.payload !== 'object') {
        return;
      }
   
      const existingFilterIndex = state.filterSurplusValues.findIndex(
        item => item.key === action.payload.key
      );
   
      if (existingFilterIndex !== -1) {
        state.filterSurplusValues[existingFilterIndex] = {
          ...state.filterSurplusValues[existingFilterIndex],
          ...action.payload
        };
      } else {
        state.filterSurplusValues.push(action.payload);
      }
    },
    addDeficitFilterValue: (state, action) => {
      if (!action.payload || typeof action.payload !== 'object') {
        return;
      }
   
      const existingFilterIndex = state.filterDeficitValues.findIndex(
        item => item.key === action.payload.key
      );
   
      if (existingFilterIndex !== -1) {
        state.filterDeficitValues[existingFilterIndex] = {
          ...state.filterDeficitValues[existingFilterIndex],
          ...action.payload
        };
      } else {
        state.filterDeficitValues.push(action.payload);
      }
    },
 
  },
  extraReducers: (builder) => {
    builder
      .addCase(suggestionFilter.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(suggestionFilter.fulfilled, (state, action) => {
        state.status = 'succeeded';
     
        const companyNames = Array.isArray(action.payload?.[0])
        ? action.payload[0].filter(item => item?.company_name).map(item => item.company_name)
        : [];
      state.shipOwners = companyNames;
 
      const IMONUMBERS = Array.isArray(action.payload?.[1])
        ? action.payload[1].filter(item => item?.imo_number).map(item => item.imo_number)
        : [];
      state.IMOnumbers = IMONUMBERS;
      })
      .addCase(suggestionFilter.rejected, (state) => {
        state.status = 'failed';
        state.IMOnumbers = null;
      })
      .addCase(updateManualPriceBreakDown.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateManualPriceBreakDown.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.manualPriceBreakDown = state.manualPriceBreakDown.map(poolData => ({
          ...poolData,
          total_value: action.payload?.data?.find(item => item.token_id === poolData.token_id)?.total_value || poolData.total_value
        }));
      })
      .addCase(updateManualPriceBreakDown.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(filterDeficitPooling.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(filterDeficitPooling.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.deficitPoolingData = action.payload;
      })
      .addCase(filterDeficitPooling.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updateVesselTable.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateVesselTable.fulfilled, (state) => {
        state.status = 'succeeded';
        state.tableDataUpdated = !state.tableDataUpdated;
      })
      .addCase(updateVesselTable.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getManualPoolPricebreakdown.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getManualPoolPricebreakdown.fulfilled, (state,action) => {
        state.status = 'succeeded';
        state.manualPriceBreakDown = action.payload;
      })
      .addCase(getManualPoolPricebreakdown.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(deletePool.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deletePool.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deletePool.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(UpdateFinalPrice.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(UpdateFinalPrice.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(UpdateFinalPrice.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getPoolRedirectData.pending, (state) => {
        state.status = 'loading';
        state.updatepoolingloading = true;
      })
      .addCase(getPoolRedirectData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.updatepoolingloading = false;
        state.poolRedirectData = action.payload;
      })
      .addCase(getPoolRedirectData.rejected, (state) => {
        state.status = 'failed';
        state.updatepoolingloading = false;
      })
      .addCase(poolingHistoryOpenDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(poolingHistoryOpenDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.intiatedpoolingData = action.payload;
       
      })
      .addCase(poolingHistoryOpenDetails.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(poolingHistory.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(poolingHistory.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.poolingHistoryData = action.payload.data;
        state.poolingHistoryPaginationData = action.payload.pagination_info;
       
      })
      .addCase(poolingHistory.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(filterSurplusPooling.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(filterSurplusPooling.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.surplusPoolingData = action.payload;
      })
      .addCase(filterSurplusPooling.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(saveOrUpdatePool.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveOrUpdatePool.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.poolDetailsData = action.payload;
      })
      .addCase(saveOrUpdatePool.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(initiatePooling.pending, (state) => {
        state.status = 'loading';
        state.initiatepoolstatus = 'loading';
        state.initiatedpoolingloading = true;
      })
      .addCase(initiatePooling.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.initiatepoolstatus = 'succeeded';
        state.initiatedpoolingloading = false;
        state.intiatedpoolingData = action.payload;
      })
      .addCase(initiatePooling.rejected, (state) => {
        state.status = 'failed';
        state.initiatepoolstatus = 'failed';
        state.initiatedpoolingloading = false;
      })
      .addCase(uploadCompanyDoc.fulfilled, (state, action) => {
        const { pool_id, company_name, doc_type, file_url } = action.payload;
      })
      .addCase(upload_company_documents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(upload_company_documents.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(upload_company_documents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Document upload failed";
      })
      .addCase(updatePoolDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePoolDocument.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePoolDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Document update failed";
      })
      .addCase(getPoolDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPoolDocuments.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getPoolDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Failed to fetch documents";
      })
      .addCase(getPoolDocumentSignedUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPoolDocumentSignedUrl.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getPoolDocumentSignedUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Failed to get signed URL";
      })
      .addCase(deleteAllPoolDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAllPoolDocuments.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAllPoolDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Failed to delete documents";
      });
     
  },
})
 
export const {
  addSurplusFilterValue,
  addDeficitFilterValue,
  updateManualPriceBreakDownData
} = poolingSlice.actions;
 
export default poolingSlice.reducer;
 